/**
 * 识别常见邮箱服务商的网页邮箱入口，用于注册成功后提供"前往收件箱"跳转。
 * 匹配不到返回 null（不展示跳转按钮）。
 */
const PROVIDERS: Record<string, string> = {
  // QQ 系
  "qq.com": "https://mail.qq.com/",
  "foxmail.com": "https://mail.qq.com/",
  "vip.qq.com": "https://mail.qq.com/",
  "foxmail": "https://mail.qq.com/",
  // 网易系
  "163.com": "https://mail.163.com/",
  "126.com": "https://mail.126.com/",
  "yeah.net": "https://mail.yeah.net/",
  "188.com": "https://www.188.com/",
  // 阿里
  "aliyun.com": "https://mail.aliyun.com/",
  // Google / Microsoft / Apple
  "gmail.com": "https://mail.google.com/",
  "outlook.com": "https://outlook.live.com/",
  "hotmail.com": "https://outlook.live.com/",
  "live.com": "https://outlook.live.com/",
  "live.cn": "https://outlook.live.com/",
  "icloud.com": "https://www.icloud.com/mail/",
  "me.com": "https://www.icloud.com/mail/",
  // 国内其他
  "sina.com": "https://mail.sina.com.cn/",
  "sina.cn": "https://mail.sina.com.cn/",
  "sohu.com": "https://mail.sohu.com/",
  "139.com": "https://mail.10086.cn/",
  // 海外常见
  "yahoo.com": "https://mail.yahoo.com/",
  "yahoo.co.jp": "https://mail.yahoo.co.jp/",
  "proton.me": "https://mail.proton.me/",
  "protonmail.com": "https://mail.proton.me/",
  "zoho.com": "https://mail.zoho.com/",
};

export function getInboxUrl(email: string): string | null {
  const at = email.lastIndexOf("@");
  if (at < 0) return null;
  const domain = email.slice(at + 1).trim().toLowerCase();
  return PROVIDERS[domain] ?? null;
}
